import { SimplePageContentWrapper, SimplePageLayout, SimplePageHeader } from '@flexinet/ui-components';
import { ReportsRecordsTable } from '../../orders/tables/ReportsRecordsTable';
import { ReportPageNavigation } from '../navigation/ReportPageNavigation';

export const OrdersReportPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<SimplePageHeader title="Orders Report" />}
      pageNavigation={<ReportPageNavigation reportName="Orders Report" />}
    >
      <SimplePageContentWrapper>
        <ReportsRecordsTable />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};